import { useFocus } from '../../../stores/stream-screen.store';
import { useStreamSelection } from '../../../stores/useStreamSelection';

/**
 * Hook that calculates the menu position for the selection menu.
 * Returns 'end' if the start is out of focus and the end is in focus, otherwise 'start'.
 */
export function useSelectionMenuPosition(): 'start' | 'end' {
  const focus = useFocus();
  const { selection } = useStreamSelection();
  const { tsA, tsB } = selection;

  // Determine menu position: show at end if start is out of focus and end is in focus
  const minTs = Math.min(tsA || Infinity, tsB || Infinity);
  const maxTs = Math.max(tsA || 0, tsB || 0);
  const startOutOfFocus = tsA && focus.from !== undefined && minTs < focus.from;
  const endInFocus =
    tsB &&
    focus.from !== undefined &&
    focus.to !== undefined &&
    maxTs >= focus.from &&
    maxTs <= focus.to;
  const menuPosition = startOutOfFocus && endInFocus ? 'end' : 'start';

  return menuPosition;
}
